module.exports = __webpack_public_path__ + "img/低压储能电池.01fe4566.png";